const RequestForm = require('./form');
const StoredEntity = require('./stored-entity');

class RequestProcessStep extends StoredEntity {

	constructor(process) {
		super();
		// this._process = process;
		Object.defineProperty(this, '_process', {
			value: process,
			enumerable: false,
			writable: false,
			configurable: false
		});
		this.role = '';
		this.forms = [];
		this.fields = [];	// { id, rev }
		this.openedDate = null;	//needed for auto-response
		this.closedDate = null;	//when all forms have been filled
		this.extraData = {};	//data controlled by rulesets that can trigger other functionality
		this.autoResponse = null;
	}

	getProcess() {
		return this._process;
	}

	getStepTemplate() {
		return this.getProcess().getPackage().getStepByRole(this.role);
	}

	setFields(f) {
		this.fields = f;
	}

	getFields() {
		return this.fields;
	}

	getFieldsLoaded() {
		return this.getStepTemplate().getFieldsLoaded().filter(f => !!this.getFields().find(e => e.id === f.getId()));
	}

	init(step, owners) {
		this.role = step.getRole();
		this.fields = step.getFields();
		this.initForms(owners);
	}

	getRole() {
		return this.role;
	}

	initForms(owners) {
		let ownerIds = new Set();
		this.forms = owners.map(owner => {
			let form = new RequestForm(this);
			form.setOwner(owner);
			return form;
		}).filter(form => {
			if (ownerIds.has(form.owner)) return false;
			ownerIds.add(form.owner);
			return true;
		})
	}

	getDataByTag(tag) {
		return this.forms.flatMap(f => f.getDataByTag(tag));
	}

	canOpen() {
		return this.forms.length > 0 && !this.closedDate;
	}

	setOpened() {
		if (this.openedDate) throw new Error('already open');
		this.openedDate = new Date();
		let tpl = this.getStepTemplate();
		if (tpl.autoResponseHours) {
			let d = new Date();
			d.setHours(d.getHours() + tpl.autoResponseHours);
			this.autoResponse = {
				date: d,
				closed: false
			};
		}
	}

	isOpen() {
		return !this.closedDate && this.openedDate;
	}

	setAutoClosed() {
		this.setClosed(true);
		if (this.autoResponse) {
			this.autoResponse.closed = true;
		}
	}

	setClosed(force) {
		if (this.closedDate) throw new Error('already closed');
		let notFilled = this.forms.find(f => !f.getFilledDate());
		if (!notFilled || force) {
			this.closedDate = new Date();
		} else {
			throw new Error('some forms still not filled, cannot close');
		}
	}

	canClose() {
		return !this.closedDate && !this.forms.find(f => !f.getFilledDate());
	}

	getFormByOwner(owner) {
		return this.forms.find(f => f.owner === owner);
	}

	getForms() {
		return this.forms;
	}

	hasAutoResponseEnabled() {
		return !!this.autoResponse;
	}

	toStorage() {
		let d = super.toStorage();
		d.forms = this.forms.map(f => f.toStorage());
		d.extraData = JSON.stringify(this.extraData);
		return d;
	}

	fromData(data) {
		// console.log('step fromData', data);
		super.fromData(data);
		this.forms = data.forms.map(fd => {
			let form = new RequestForm(this);
			form.fromData(fd);
			return form;
		});
		this.openedDate = data.openedDate ? new Date(data.openedDate) : null;
		this.closedDate = data.closedDate ? new Date(data.closedDate) : null;
		if (typeof data.extraData === 'string') this.extraData = JSON.parse(data.extraData);
	}

}


module.exports = RequestProcessStep;
